import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { StoreService } from '@app/shared/services/store.service';
import { NestedLink } from '../../../../shared/interfaces/nested-link';

@Component({
    selector: 'app-header-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent {
    @Input() layout: 'classic'|'topbar' = 'classic';
    @Input() items: NestedLink[] = [];

    constructor(
        public store: StoreService,
        private router: Router,
        private auth: AuthenticationService
        ) { }

    logout() {
        this.auth.logout();
        //this.router.navigate(['/account/login']);
    }

}
